import { useCookie } from "@/features/shared/cookies/use-cookie.hook";
import { StorageUtils } from "@/features/shared/storage/storage.utils";
import { removeCentralCipTokenHeader } from "@/services/config/api";
import { isStaffIdToken, signOutOfStaff } from "@/services/staff.services";

export default function useOnLogout() {
  const { value: cipCookie, remove: removeCipToken } = useCookie<string>("cnp_cip_token");
  const { remove: removeServicesToken } = useCookie<string>("cnp_services_token");
  return async (): Promise<void> => {
    StorageUtils.clear();
    // Only our own central-server session: a staff token there is Central's, and removing it would sign Central out.
    if (!isStaffIdToken(cipCookie)) removeCipToken();
    removeServicesToken();
    removeCentralCipTokenHeader();
    // The staff session is saved in this browser: it must be gone before the reload, or it signs right back in.
    await signOutOfStaff().catch(() => undefined);
    window.location.href = "/";
  };
}
